function menu_slide() {
  const activeTabLink = document.querySelector(".imkt-tab-list a.active") ? document.querySelector(".imkt-tab-list a.active") : document.querySelector(".imkt-tab-list a");
  const menuBG = document.getElementById("menu-bg");

  if (activeTabLink) {
    const li = activeTabLink.parentNode;
    if (li && li.offsetHeight) {
      menuBG.style.cssText = `
          left: ${li.offsetLeft}px;
          width: ${li.offsetWidth}px;
      `;
    }
  }
}

window.addEventListener("resize", () => {
  menu_slide();
});

const listEl = document.querySelector(".imkt-tab-list");
if (listEl) {
  const newEl = document.createElement("li");
  newEl.id = "menu-bg";
  listEl.prepend(newEl);
  listEl.addEventListener("click", () => {
    menu_slide();
  });
  menu_slide();
}
